import PickupReadinessDispensaryCard from "./PickupReadinessDispensaryCard";

export default PickupReadinessDispensaryCard;
